import { type PropsWithChildren, useEffect } from "react";

interface ModalProps extends PropsWithChildren {
  open: boolean;
  title: string;
  onClose(): void;
}

export function Modal({ open, title, onClose, children }: ModalProps) {
  useEffect(() => {
    if (!open) return;
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [onClose, open]);

  if (!open) return null;
  return (
    <div className="modal-backdrop">
      <button
        className="modal-dismiss-layer"
        type="button"
        onClick={onClose}
        aria-label="Cerrar diálogo"
      />
      <section className="modal-panel" role="dialog" aria-modal="true" aria-label={title}>
        <header className="modal-panel__header">
          <div>
            <span className="eyebrow">Eremos workspace</span>
            <h2>{title}</h2>
          </div>
          <button className="icon-button" type="button" onClick={onClose} aria-label="Cerrar">
            ×
          </button>
        </header>
        {children}
      </section>
    </div>
  );
}
